
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.87 2.779l1.393 2.786c.19.388.696.76 1.124.832l2.525.42c1.615.268 1.995 1.44.832 2.596l-1.964 1.963c-.332.333-.514.974-.411 1.433l.562 2.43c.443 1.924-.578 2.668-2.28 1.663L10.284 15.5c-.428-.254-1.133-.254-1.568 0L6.35 16.9c-1.694 1.006-2.723.254-2.28-1.662l.562-2.43c.103-.46-.08-1.1-.412-1.433L2.256 9.413c-1.156-1.156-.784-2.328.831-2.597l2.526-.42c.42-.07.926-.443 1.116-.83l1.393-2.787c.76-1.512 1.995-1.512 2.747 0z","fill":"#FFC700","stroke":"#FFC700","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    